import React, { useContext, useEffect, useState } from 'react'
import { IProjectModel, ThemeTypes } from '../../models/SharedModel';
import Service from '../../services';
import { toast } from 'react-toastify';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import ProjectForm from '../shared/ProjectForm';
import { useNavigate } from 'react-router-dom';
import { RoutesEnum } from '../../models/RoutesModel';
import { ProjectStatus } from '../../models/ProjectModel';
import { getFromSession } from '../../helpers/GenericHelpers';
import { ThemeContext } from '../../models/ThemeContext';

interface INewProjectModalProps {
  projectModal: boolean;
  toggleProjectModal: () => void;
  apiSuccessCallback?: Function;
  selectedProject?: IProjectModel | null
}

const NewProjectModal = (props: INewProjectModalProps) => {
  const { projectModal, toggleProjectModal, apiSuccessCallback, selectedProject } = props;
  const service = new Service();
  const navigate = useNavigate();

  // states
  const [project, setProject] = useState<Partial<IProjectModel> | null>({}); // set project data for the modal

  // helpers 
  const cancelProject = (project?: Partial<IProjectModel>) => {
    setProject({})
    toggleProjectModal()
  }

  const toggleProjectCancelModal = () => {
    cancelProject()
  }

  // apis
  const user_id = getFromSession('user_id');
  const user_name = getFromSession('user_name');
  const create_project = (project: IProjectModel) => {
    console.log(project)
    service
      .create_project({ ...project, version: project?.version || "0.1",user_id:user_id,username:user_name })
      .then((res) => {
        if(res?.data === 'Project name already exists'){
          toast.error(res?.data);
        }else{
          const data ={
            project_id: res?.data?.project_id,
            model_name:project?.model,
            open_ai_key: project?.open_ai_key,
            temperature: parseInt(project?.temperature)/10,
            chunk_overlap: project?.chunk_overlap ,
            chunk_size: project?.chunk_size,
            engine:project?.engine,
            embeddedModal:project?.embeddedModal, 
            project_description : project?.project_description,
            llamaparse_api_key : project?.llamaparse_api_key
        }
          addConfig(data)
          apiSuccessCallback && apiSuccessCallback(res?.data)
        }
      })
      .catch((err) => console.log(err));
  };

  const addConfig = (data:any) =>{
    console.log('Data test')
    console.log(data)
    service?.add_project_configuration(data).then((response:any)=>{
      navigate(`/${RoutesEnum.LANDING}`)
      cancelProject();
      response?.data && toast.success('Solution Created');
      setProject({})
    }).catch((error:any)=>{
      console.log(error)
      toast.error('something went wrong')
    })
  }
  // use Effects

  useEffect(() => {
    setProject(selectedProject || null)
  }, [selectedProject])

  const { themeName } = useContext(ThemeContext);
  // className={`project-modal templateModal ${themeName === ThemeTypes?.BLUE_THEME ? '' : 'dark-modal'}`}
  return (
    <Modal
      className={`project-modal ${themeName === ThemeTypes?.BLUE_THEME ? '' : 'dark-modal'}`}
      isOpen={projectModal}
      toggle={toggleProjectCancelModal}
    >
      <ModalHeader toggle={toggleProjectCancelModal}>{
        selectedProject ? 'Create New Version' : 'Create New Solution' 
      }</ModalHeader>
      <ModalBody>
        <ProjectForm 
          project={project} 
          setProject={setProject} 
          submitProject={create_project} 
          selectedProject={selectedProject} 
          cancelProject={cancelProject}
        />
      </ModalBody>
    </Modal>
  )
}

export default NewProjectModal